import script from "./GameStatsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./GameStatsPanel.vue?vue&type=script&setup=true&lang=js"

import "./GameStatsPanel.vue?vue&type=style&index=0&id=2081dc3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2081dc3a"]])

export default __exports__